import _regeneratorRuntime from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/Users/bolshchikov/Documents/src/github.com/orbs-network/conversation/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _Object$freeze, _Object$freeze2, _Object$freeze3, _Object$freeze4;

import elliptic from 'elliptic';
import hash from 'hash.js';
import axios from 'axios';
var ED25519_PUBLIC_KEY_SIZE_BYTES = 32;
var ED25519_PRIVATE_KEY_SIZE_BYTES = 64;

function generateEd25519Key() {
  // generate secure random
  var getRandomValues = require("get-random-values");

  var secureRandom = new Uint8Array(ED25519_PRIVATE_KEY_SIZE_BYTES - ED25519_PUBLIC_KEY_SIZE_BYTES);
  getRandomValues(secureRandom); // generate key

  var ec = new elliptic.eddsa("ed25519");
  var key = ec.keyFromSecret(uint8ArrayToHexString(secureRandom)); // console.log(key.getPublic("hex"));
  // console.log(key.getSecret("hex"));
  // return

  var publicKey = new Uint8Array(key.getPublic("bytes"));
  var privateKey = new Uint8Array(ED25519_PRIVATE_KEY_SIZE_BYTES);
  privateKey.set(new Uint8Array(key.getSecret("bytes")), 0);
  privateKey.set(publicKey, ED25519_PRIVATE_KEY_SIZE_BYTES - ED25519_PUBLIC_KEY_SIZE_BYTES);
  return {
    publicKey: publicKey,
    privateKey: privateKey
  };
}

function uint8ArrayToHexString(arr) {
  return Array.prototype.map.call(arr, function (x) {
    return ("00" + x.toString(16)).slice(-2);
  }).join("");
}

var SHA256_HASH_SIZE_BYTES = 32;

function calcSha256(data) {
  var inputArr = [].slice.call(data);
  var outputArr = hash.sha256().update(inputArr).digest();
  return new Uint8Array(outputArr);
}

var CLIENT_ADDRESS_SIZE_BYTES = 20;
var CLIENT_ADDRESS_SHA256_OFFSET = SHA256_HASH_SIZE_BYTES - CLIENT_ADDRESS_SIZE_BYTES;
var TX_ID_SIZE_BYTES = 8 + 32;

function calcClientAddressOfEd25519PublicKey(publicKey) {
  if (publicKey.byteLength != ED25519_PUBLIC_KEY_SIZE_BYTES) {
    throw new Error("public key has invalid length ".concat(publicKey.byteLength));
  }

  return calcSha256(publicKey).slice(CLIENT_ADDRESS_SHA256_OFFSET);
}

function calcTxHash(transactionBuf) {
  return calcSha256(transactionBuf);
}

function generateTxId(txHash, txTimestamp) {
  var res = new Uint8Array(TX_ID_SIZE_BYTES);
  var dataView = new DataView(res.buffer, res.byteOffset);
  dataView.setBigUint64(0, txTimestamp, true);
  res.set(txHash, 8);
  return res;
}

function extractTxId(txId) {
  if (txId.byteLength != TX_ID_SIZE_BYTES) {
    throw new Error("txid has invalid length ".concat(txId.byteLength));
  }

  var dataView = new DataView(txId.buffer, txId.byteOffset);
  var txTimestamp = dataView.getBigUint64(0, true);
  var txHash = txId.subarray(8);
  return [txHash, txTimestamp];
}

var textEncoder = null;

function getTextEncoder() {
  if (textEncoder === null) {
    if (typeof TextEncoder === "undefined") {
      // node.js does not support TextEncoder
      require("fast-text-encoding");
    }

    textEncoder = new TextEncoder();
  }

  return textEncoder;
}

var textDecoder = null;

function getTextDecoder() {
  if (textDecoder === null) {
    if (typeof TextDecoder === "undefined") {
      // node.js does not support TextDecoder
      require("fast-text-encoding");
    }

    textDecoder = new TextDecoder("utf-8");
  }

  return textDecoder;
} // without 0x


function simpleHexEncodeAsCharCodeArray(data) {
  var res = new Uint8Array(2 * data.byteLength);

  for (var i = 0; i < data.byteLength; i++) {
    var hex = "00" + data[i].toString(16).toLowerCase();
    res[2 * i] = hex.charCodeAt(hex.length - 2);
    res[2 * i + 1] = hex.charCodeAt(hex.length - 1);
  }

  return res;
} // without 0x


function simpleHexDecode(str) {
  if (str.length % 2 != 0) {
    throw new Error("invalid hex string '".concat(str, "'"));
  }

  var res = new Uint8Array(str.length / 2);

  for (var i = 0; i < str.length; i += 2) {
    var byte = parseInt(str.substr(i, 2), 16);

    if (isNaN(byte)) {
      throw new Error("invalid hex string '".concat(str, "'"));
    }

    res[i / 2] = byte;
  }

  return res;
}

function encodeHex(data) {
  var result = simpleHexEncodeAsCharCodeArray(data);
  var hashed = calcSha256(data);

  for (var i = 0; i < 2 * data.byteLength; i++) {
    var byteIndex = Math.floor(i / 2);
    var hashByte = hashed[byteIndex % SHA256_HASH_SIZE_BYTES];

    if (i % 2 == 0) {
      hashByte = hashByte >> 4;
    } else {
      hashByte &= 0xf;
    } // 57 = "9"


    if (result[i] > 57 && hashByte > 7) {
      result[i] -= 32;
    }
  }

  return "0x" + getTextDecoder().decode(result);
}

function decodeHex(str) {
  if (str.startsWith("0x")) {
    str = str.slice(2);
  }

  var data = simpleHexDecode(str);
  var encoded = encodeHex(data);

  if (encoded.slice(2) != str) {
    // checksum error, we will allow if the source is in uniform case (all lower/upper)
    if (str.toUpperCase() == str || str.toLowerCase() == str) {
      return data;
    } else {
      throw new Error("invalid checksum on hex string '".concat(str, "'"));
    }
  }

  return data;
}

function createAccount() {
  var keyPair = generateEd25519Key();
  var rawAddress = calcClientAddressOfEd25519PublicKey(keyPair.publicKey);
  return {
    publicKey: keyPair.publicKey,
    privateKey: keyPair.privateKey,
    address: bytesToAddress(rawAddress)
  };
}

function addressToBytes(address) {
  return decodeHex(address);
}

function bytesToAddress(rawAddress) {
  return encodeHex(rawAddress);
}

var ExecutionResult;

(function (ExecutionResult) {
  ExecutionResult["EXECUTION_RESULT_SUCCESS"] = "SUCCESS";
  ExecutionResult["EXECUTION_RESULT_ERROR_SMART_CONTRACT"] = "ERROR_SMART_CONTRACT";
  ExecutionResult["EXECUTION_RESULT_ERROR_INPUT"] = "ERROR_INPUT";
  ExecutionResult["EXECUTION_RESULT_ERROR_CONTRACT_NOT_DEPLOYED"] = "ERROR_CONTRACT_NOT_DEPLOYED";
  ExecutionResult["EXECUTION_RESULT_ERROR_UNEXPECTED"] = "ERROR_UNEXPECTED";
  ExecutionResult["EXECUTION_RESULT_NOT_EXECUTED"] = "NOT_EXECUTED";
})(ExecutionResult || (ExecutionResult = {}));

function executionResultDecode(executionResult) {
  switch (executionResult) {
    case 0:
      throw new Error("reserved ExecutionResult received");

    case 1:
      return ExecutionResult.EXECUTION_RESULT_SUCCESS;

    case 2:
      return ExecutionResult.EXECUTION_RESULT_ERROR_SMART_CONTRACT;

    case 3:
      return ExecutionResult.EXECUTION_RESULT_ERROR_INPUT;

    case 4:
      return ExecutionResult.EXECUTION_RESULT_ERROR_CONTRACT_NOT_DEPLOYED;

    case 5:
      return ExecutionResult.EXECUTION_RESULT_ERROR_UNEXPECTED;

    case 6:
      return ExecutionResult.EXECUTION_RESULT_NOT_EXECUTED;

    default:
      throw new Error("unsupported ExecutionResult received: ".concat(executionResult));
  }
}

var RequestStatus;

(function (RequestStatus) {
  RequestStatus["REQUEST_STATUS_COMPLETED"] = "COMPLETED";
  RequestStatus["REQUEST_STATUS_IN_PROCESS"] = "IN_PROCESS";
  RequestStatus["REQUEST_STATUS_BAD_REQUEST"] = "BAD_REQUEST";
  RequestStatus["REQUEST_STATUS_CONGESTION"] = "CONGESTION";
  RequestStatus["REQUEST_STATUS_SYSTEM_ERROR"] = "SYSTEM_ERROR";
  RequestStatus["REQUEST_STATUS_OUT_OF_SYNC"] = "OUT_OF_SYNC";
  RequestStatus["REQUEST_STATUS_NOT_FOUND"] = "NOT_FOUND";
})(RequestStatus || (RequestStatus = {}));

function requestStatusDecode(requestStatus) {
  switch (requestStatus) {
    case 0:
      throw new Error("reserved RequestStatus received");

    case 1:
      return RequestStatus.REQUEST_STATUS_COMPLETED;

    case 2:
      return RequestStatus.REQUEST_STATUS_IN_PROCESS;

    case 3:
      return RequestStatus.REQUEST_STATUS_BAD_REQUEST;

    case 4:
      return RequestStatus.REQUEST_STATUS_CONGESTION;

    case 5:
      return RequestStatus.REQUEST_STATUS_SYSTEM_ERROR;

    case 6:
      return RequestStatus.REQUEST_STATUS_OUT_OF_SYNC;

    case 7:
      return RequestStatus.REQUEST_STATUS_NOT_FOUND;

    default:
      throw new Error("unsupported RequestStatus received: ".concat(requestStatus));
  }
}

var NetworkType;

(function (NetworkType) {
  NetworkType["NETWORK_TYPE_MAIN_NET"] = "MAIN_NET";
  NetworkType["NETWORK_TYPE_TEST_NET"] = "TEST_NET";
})(NetworkType || (NetworkType = {}));

function networkTypeEncode(networkType) {
  switch (networkType) {
    case NetworkType.NETWORK_TYPE_MAIN_NET:
      return 77;

    case NetworkType.NETWORK_TYPE_TEST_NET:
      return 84;

    default:
      throw new Error("unsupported network type given ".concat(networkType));
  }
}

var FieldTypes = Object.freeze({
  TypeMessage: 1,
  TypeBytes: 2,
  TypeString: 3,
  TypeUnion: 4,
  TypeUint8: 11,
  TypeUint16: 12,
  TypeUint32: 13,
  TypeUint64: 14,
  TypeUint8Array: 21,
  TypeUint16Array: 22,
  TypeUint32Array: 23,
  TypeUint64Array: 24,
  TypeMessageArray: 31,
  TypeBytesArray: 32,
  TypeStringArray: 33
});
var FieldSizes = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, FieldTypes.TypeMessage, 4), _defineProperty(_Object$freeze, FieldTypes.TypeBytes, 4), _defineProperty(_Object$freeze, FieldTypes.TypeString, 4), _defineProperty(_Object$freeze, FieldTypes.TypeUnion, 2), _defineProperty(_Object$freeze, FieldTypes.TypeUint8, 1), _defineProperty(_Object$freeze, FieldTypes.TypeUint16, 2), _defineProperty(_Object$freeze, FieldTypes.TypeUint32, 4), _defineProperty(_Object$freeze, FieldTypes.TypeUint64, 8), _defineProperty(_Object$freeze, FieldTypes.TypeUint8Array, 4), _defineProperty(_Object$freeze, FieldTypes.TypeUint16Array, 4), _defineProperty(_Object$freeze, FieldTypes.TypeUint32Array, 4), _defineProperty(_Object$freeze, FieldTypes.TypeUint64Array, 4), _defineProperty(_Object$freeze, FieldTypes.TypeMessageArray, 4), _defineProperty(_Object$freeze, FieldTypes.TypeBytesArray, 4), _defineProperty(_Object$freeze, FieldTypes.TypeStringArray, 4), _Object$freeze));
var FieldAlignment = Object.freeze((_Object$freeze2 = {}, _defineProperty(_Object$freeze2, FieldTypes.TypeMessage, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeBytes, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeString, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUnion, 2), _defineProperty(_Object$freeze2, FieldTypes.TypeUint8, 1), _defineProperty(_Object$freeze2, FieldTypes.TypeUint16, 2), _defineProperty(_Object$freeze2, FieldTypes.TypeUint32, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUint64, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUint8Array, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUint16Array, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUint32Array, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeUint64Array, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeMessageArray, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeBytesArray, 4), _defineProperty(_Object$freeze2, FieldTypes.TypeStringArray, 4), _Object$freeze2));
var FieldDynamic = Object.freeze((_Object$freeze3 = {}, _defineProperty(_Object$freeze3, FieldTypes.TypeMessage, true), _defineProperty(_Object$freeze3, FieldTypes.TypeBytes, true), _defineProperty(_Object$freeze3, FieldTypes.TypeString, true), _defineProperty(_Object$freeze3, FieldTypes.TypeUnion, true), _defineProperty(_Object$freeze3, FieldTypes.TypeUint8, false), _defineProperty(_Object$freeze3, FieldTypes.TypeUint16, false), _defineProperty(_Object$freeze3, FieldTypes.TypeUint32, false), _defineProperty(_Object$freeze3, FieldTypes.TypeUint64, false), _defineProperty(_Object$freeze3, FieldTypes.TypeUint8Array, true), _defineProperty(_Object$freeze3, FieldTypes.TypeUint16Array, true), _defineProperty(_Object$freeze3, FieldTypes.TypeUint32Array, true), _defineProperty(_Object$freeze3, FieldTypes.TypeUint64Array, true), _defineProperty(_Object$freeze3, FieldTypes.TypeMessageArray, true), _defineProperty(_Object$freeze3, FieldTypes.TypeBytesArray, true), _defineProperty(_Object$freeze3, FieldTypes.TypeStringArray, true), _Object$freeze3));
var FieldDynamicContentAlignment = Object.freeze((_Object$freeze4 = {}, _defineProperty(_Object$freeze4, FieldTypes.TypeMessage, 4), _defineProperty(_Object$freeze4, FieldTypes.TypeBytes, 1), _defineProperty(_Object$freeze4, FieldTypes.TypeString, 1), _defineProperty(_Object$freeze4, FieldTypes.TypeUnion, 0), _defineProperty(_Object$freeze4, FieldTypes.TypeUint8, 0), _defineProperty(_Object$freeze4, FieldTypes.TypeUint16, 0), _defineProperty(_Object$freeze4, FieldTypes.TypeUint32, 0), _defineProperty(_Object$freeze4, FieldTypes.TypeUint64, 0), _defineProperty(_Object$freeze4, FieldTypes.TypeUint8Array, 1), _defineProperty(_Object$freeze4, FieldTypes.TypeUint16Array, 2), _defineProperty(_Object$freeze4, FieldTypes.TypeUint32Array, 4), _defineProperty(_Object$freeze4, FieldTypes.TypeUint64Array, 4), _defineProperty(_Object$freeze4, FieldTypes.TypeMessageArray, 4), _defineProperty(_Object$freeze4, FieldTypes.TypeBytesArray, 4), _defineProperty(_Object$freeze4, FieldTypes.TypeStringArray, 4), _Object$freeze4));

var ArrayIterator =
/*#__PURE__*/
function () {
  function ArrayIterator(cursor, endCursor, fieldType, m) {
    _classCallCheck(this, ArrayIterator);

    this.cursor = cursor;
    this.endCursor = endCursor;
    this.fieldType = fieldType;
    this.m = m;
  }

  _createClass(ArrayIterator, [{
    key: "hasNext",
    value: function hasNext() {
      return this.cursor < this.endCursor;
    }
  }, {
    key: "nextUint8",
    value: function nextUint8() {
      if (this.cursor + FieldSizes[FieldTypes.TypeUint8] > this.endCursor) {
        this.cursor = this.endCursor;
        return 0;
      }

      var res = this.m.getUint8InOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeUint8];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeUint8Array);
      return res;
    }
  }, {
    key: "nextUint16",
    value: function nextUint16() {
      if (this.cursor + FieldSizes[FieldTypes.TypeUint16] > this.endCursor) {
        this.cursor = this.endCursor;
        return 0;
      }

      var res = this.m.getUint16InOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeUint16];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeUint16Array);
      return res;
    }
  }, {
    key: "nextUint32",
    value: function nextUint32() {
      if (this.cursor + FieldSizes[FieldTypes.TypeUint32] > this.endCursor) {
        this.cursor = this.endCursor;
        return 0;
      }

      var res = this.m.getUint32InOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeUint32];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeUint32Array);
      return res;
    }
  }, {
    key: "nextUint64",
    value: function nextUint64() {
      if (this.cursor + FieldSizes[FieldTypes.TypeUint64] > this.endCursor) {
        this.cursor = this.endCursor;
        return BigInt(0);
      }

      var res = this.m.getUint64InOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeUint64];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeUint64Array);
      return res;
    }
  }, {
    key: "nextMessage",
    value: function nextMessage() {
      if (this.cursor + FieldSizes[FieldTypes.TypeMessage] > this.endCursor) {
        this.cursor = this.endCursor;
        return [new Uint8Array(), 0];
      }

      var resSize = this.m.getOffsetInOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeMessage];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeMessage);

      if (this.cursor + resSize > this.endCursor) {
        this.cursor = this.endCursor;
        return [new Uint8Array(), 0];
      }

      var resBuf = this.m.bytes.subarray(this.cursor, this.cursor + resSize);
      this.cursor += resSize;
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeMessageArray);
      return [resBuf, resSize];
    }
  }, {
    key: "nextBytes",
    value: function nextBytes() {
      if (this.cursor + FieldSizes[FieldTypes.TypeBytes] > this.endCursor) {
        this.cursor = this.endCursor;
        return new Uint8Array();
      }

      var resSize = this.m.getOffsetInOffset(this.cursor);
      this.cursor += FieldSizes[FieldTypes.TypeBytes];
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeBytes);

      if (this.cursor + resSize > this.endCursor) {
        this.cursor = this.endCursor;
        return new Uint8Array();
      }

      var resBuf = this.m.bytes.subarray(this.cursor, this.cursor + resSize);
      this.cursor += resSize;
      this.cursor = alignDynamicFieldContentOffset(this.cursor, FieldTypes.TypeBytesArray);
      return resBuf;
    }
  }, {
    key: "nextString",
    value: function nextString() {
      var b = this.nextBytes();
      return getTextDecoder().decode(b);
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      var _this = this;

      return {
        next: function next() {
          if (_this.hasNext()) {
            switch (_this.fieldType) {
              case FieldTypes.TypeUint8:
                return {
                  value: _this.nextUint8(),
                  done: false
                };

              case FieldTypes.TypeUint16:
                return {
                  value: _this.nextUint16(),
                  done: false
                };

              case FieldTypes.TypeUint32:
                return {
                  value: _this.nextUint32(),
                  done: false
                };

              case FieldTypes.TypeUint64:
                return {
                  value: _this.nextUint64(),
                  done: false
                };

              case FieldTypes.TypeMessage:
                return {
                  value: _this.nextMessage(),
                  done: false
                };

              case FieldTypes.TypeBytes:
                return {
                  value: _this.nextBytes(),
                  done: false
                };

              case FieldTypes.TypeString:
                return {
                  value: _this.nextString(),
                  done: false
                };

              default:
                throw new Error("unsupported array type");
            }
          } else {
            return {
              done: true,
              value: undefined
            };
          }
        }
      };
    }
  }]);

  return ArrayIterator;
}();

function alignOffsetToType(off, fieldType) {
  var fieldSize = FieldAlignment[fieldType];
  return Math.floor((off + fieldSize - 1) / fieldSize) * fieldSize;
}

function alignDynamicFieldContentOffset(off, fieldType) {
  var contentAlignment = FieldDynamicContentAlignment[fieldType];
  return Math.floor((off + contentAlignment - 1) / contentAlignment) * contentAlignment;
}

var InternalMessage =
/*#__PURE__*/
function () {
  function InternalMessage(buf, size, scheme, unions) {
    _classCallCheck(this, InternalMessage);

    this.size = size;
    this.scheme = scheme;
    this.unions = unions;
    this.bytes = buf; // buf should be Uint8Array (a view over an ArrayBuffer)

    this.dataView = new DataView(buf.buffer, buf.byteOffset);
    this.offsets = null; // map: fieldNum -> offset in bytes
  }

  _createClass(InternalMessage, [{
    key: "lazyCalcOffsets",
    value: function lazyCalcOffsets() {
      if (this.offsets !== null) {
        return true;
      }

      var res = {};
      var off = 0;
      var unionNum = 0;

      for (var fieldNum = 0; fieldNum < this.scheme.length; fieldNum++) {
        var fieldType = this.scheme[fieldNum]; // write the current offset

        off = alignOffsetToType(off, fieldType);

        if (off >= this.size) {
          return false;
        }

        res[fieldNum] = off; // skip over the content to the next field

        if (fieldType == FieldTypes.TypeUnion) {
          if (off + FieldSizes[FieldTypes.TypeUnion] > this.size) {
            return false;
          }

          var unionType = this.dataView.getUint16(off, true);
          off += FieldSizes[FieldTypes.TypeUnion];

          if (unionNum >= this.unions.length || unionType >= this.unions[unionNum].length) {
            return false;
          }

          fieldType = this.unions[unionNum][unionType];
          unionNum += 1;
          off = alignOffsetToType(off, fieldType);
        }

        if (FieldDynamic[fieldType]) {
          if (off + FieldSizes[fieldType] > this.size) {
            return false;
          }

          var contentSize = this.dataView.getUint32(off, true);
          off += FieldSizes[fieldType];
          off = alignDynamicFieldContentOffset(off, fieldType);
          off += contentSize;
        } else {
          off += FieldSizes[fieldType];
        }
      }

      if (off > this.size) {
        return false;
      }

      this.offsets = res;
      return true;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (this.bytes === undefined) {
        throw "uninitialized membuffer, did you create it directly without a Builder or a Reader?";
      }

      return this.lazyCalcOffsets();
    }
  }, {
    key: "rawBuffer",
    value: function rawBuffer() {
      return this.bytes.subarray(0, this.size);
    }
  }, {
    key: "rawBufferForField",
    value: function rawBufferForField(fieldNum, unionNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length || fieldNum >= this.scheme.length) {
        return new Uint8Array();
      }

      var fieldType = this.scheme[fieldNum];
      var off = this.offsets[fieldNum];

      if (fieldType == FieldTypes.TypeUnion) {
        var unionType = this.dataView.getUint16(off, true);
        off += FieldSizes[FieldTypes.TypeUnion];

        if (unionNum >= this.unions.length || unionType >= this.unions[unionNum].length) {
          return new Uint8Array();
        }

        fieldType = this.unions[unionNum][unionType];
        off = alignOffsetToType(off, fieldType);
      }

      if (FieldDynamic[fieldType]) {
        var contentSize = this.dataView.getUint32(off, true);
        off += FieldSizes[fieldType];
        off = alignDynamicFieldContentOffset(off, fieldType);
        return this.bytes.subarray(off, off + contentSize);
      } else {
        return this.bytes.subarray(off, off + FieldSizes[fieldType]);
      }
    }
  }, {
    key: "rawBufferWithHeaderForField",
    value: function rawBufferWithHeaderForField(fieldNum, unionNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length || fieldNum >= this.scheme.length) {
        return new Uint8Array();
      }

      var fieldType = this.scheme[fieldNum];
      var off = this.offsets[fieldNum];
      var fieldHeaderOff = off;

      if (fieldType == FieldTypes.TypeUnion) {
        var unionType = this.dataView.getUint16(off, true);
        off += FieldSizes[FieldTypes.TypeUnion];

        if (unionNum >= this.unions.length || unionType >= this.unions[unionNum].length) {
          return new Uint8Array();
        }

        fieldType = this.unions[unionNum][unionType];
        off = alignOffsetToType(off, fieldType);
      }

      if (FieldDynamic[fieldType]) {
        var contentSize = this.dataView.getUint32(off, true);
        off += FieldSizes[fieldType];
        off = alignDynamicFieldContentOffset(off, fieldType);
        return this.bytes.subarray(fieldHeaderOff, off + contentSize);
      } else {
        return this.bytes.subarray(fieldHeaderOff, off + FieldSizes[fieldType]);
      }
    }
  }, {
    key: "getOffsetInOffset",
    value: function getOffsetInOffset(off) {
      return this.dataView.getUint32(off, true);
    }
  }, {
    key: "getUint8InOffset",
    value: function getUint8InOffset(off) {
      return this.dataView.getUint8(off);
    }
  }, {
    key: "setUint8InOffset",
    value: function setUint8InOffset(off, v) {
      return this.dataView.setUint8(off, v);
    }
  }, {
    key: "getUint8",
    value: function getUint8(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return 0;
      }

      var off = this.offsets[fieldNum];
      return this.getUint8InOffset(off);
    }
  }, {
    key: "setUint8",
    value: function setUint8(fieldNum, v) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        throw new Error("invalid field");
      }

      var off = this.offsets[fieldNum];
      return this.setUint8InOffset(off, v);
    }
  }, {
    key: "getUint16InOffset",
    value: function getUint16InOffset(off) {
      return this.dataView.getUint16(off, true);
    }
  }, {
    key: "setUint16InOffset",
    value: function setUint16InOffset(off, v) {
      return this.dataView.setUint16(off, v, true);
    }
  }, {
    key: "getUint16",
    value: function getUint16(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return 0;
      }

      var off = this.offsets[fieldNum];
      return this.getUint16InOffset(off);
    }
  }, {
    key: "setUint16",
    value: function setUint16(fieldNum, v) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        throw new Error("invalid field");
      }

      var off = this.offsets[fieldNum];
      return this.setUint16InOffset(off, v);
    }
  }, {
    key: "getUint32InOffset",
    value: function getUint32InOffset(off) {
      return this.dataView.getUint32(off, true);
    }
  }, {
    key: "setUint32InOffset",
    value: function setUint32InOffset(off, v) {
      return this.dataView.setUint32(off, v, true);
    }
  }, {
    key: "getUint32",
    value: function getUint32(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return 0;
      }

      var off = this.offsets[fieldNum];
      return this.getUint32InOffset(off);
    }
  }, {
    key: "setUint32",
    value: function setUint32(fieldNum, v) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        throw new Error("invalid field");
      }

      var off = this.offsets[fieldNum];
      return this.setUint32InOffset(off, v);
    }
  }, {
    key: "getUint64InOffset",
    value: function getUint64InOffset(off) {
      return this.dataView.getBigUint64(off, true);
    }
  }, {
    key: "setUint64InOffset",
    value: function setUint64InOffset(off, v) {
      return this.dataView.setBigUint64(off, v, true);
    }
  }, {
    key: "getUint64",
    value: function getUint64(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return BigInt(0);
      }

      var off = this.offsets[fieldNum];
      return this.getUint64InOffset(off);
    }
  }, {
    key: "setUint64",
    value: function setUint64(fieldNum, v) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        throw new Error("invalid field");
      }

      var off = this.offsets[fieldNum];
      return this.setUint64InOffset(off, v);
    }
  }, {
    key: "getMessageInOffset",
    value: function getMessageInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeMessage];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeMessage);
      return this.bytes.subarray(off, off + contentSize);
    }
  }, {
    key: "getMessage",
    value: function getMessage(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new Uint8Array();
      }

      var off = this.offsets[fieldNum];
      return this.getMessageInOffset(off);
    }
  }, {
    key: "getBytesInOffset",
    value: function getBytesInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeBytes];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeBytes);

      if (off + contentSize > this.bytes.byteLength) {
        return new Uint8Array();
      }

      return this.bytes.subarray(off, off + contentSize);
    }
  }, {
    key: "setBytesInOffset",
    value: function setBytesInOffset(off, v) {
      var contentSize = this.dataView.getUint32(off, true);

      if (contentSize != v.byteLength) {
        throw new Error("size mismatch");
      }

      off += FieldSizes[FieldTypes.TypeBytes];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeBytes);
      return this.bytes.set(v, off);
    }
  }, {
    key: "getBytes",
    value: function getBytes(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new Uint8Array();
      }

      var off = this.offsets[fieldNum];
      return this.getBytesInOffset(off);
    }
  }, {
    key: "setBytes",
    value: function setBytes(fieldNum, v) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        throw new Error("invalid field");
      }

      var off = this.offsets[fieldNum];
      return this.setBytesInOffset(off, v);
    }
  }, {
    key: "getStringInOffset",
    value: function getStringInOffset(off) {
      var b = this.getBytesInOffset(off);
      return getTextDecoder().decode(b);
    }
  }, {
    key: "setStringInOffset",
    value: function setStringInOffset(off, v) {
      return this.setBytesInOffset(off, getTextEncoder().encode(v));
    }
  }, {
    key: "getString",
    value: function getString(fieldNum) {
      var b = this.getBytes(fieldNum);
      return getTextDecoder().decode(b);
    }
  }, {
    key: "setString",
    value: function setString(fieldNum, v) {
      return this.setBytes(fieldNum, getTextEncoder().encode(v));
    }
  }, {
    key: "getUnionIndex",
    value: function getUnionIndex(fieldNum, unionNum) {
      var invalidUnionIndex = 0xffff;

      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return invalidUnionIndex;
      }

      var off = this.offsets[fieldNum];
      var unionType = this.dataView.getUint16(off, true);
      off += FieldSizes[FieldTypes.TypeUnion];

      if (unionNum >= this.unions.length || unionType >= this.unions[unionNum].length) {
        return invalidUnionIndex;
      }

      var fieldType = this.unions[unionNum][unionType];
      off = alignOffsetToType(off, fieldType);
      return unionType;
    }
  }, {
    key: "isUnionIndex",
    value: function isUnionIndex(fieldNum, unionNum, unionIndex) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return [false, 0];
      }

      var off = this.offsets[fieldNum];
      var unionType = this.dataView.getUint16(off, true);
      off += FieldSizes[FieldTypes.TypeUnion];

      if (unionNum >= this.unions.length || unionType >= this.unions[unionNum].length) {
        return [false, 0];
      }

      var fieldType = this.unions[unionNum][unionType];
      off = alignOffsetToType(off, fieldType);
      return [unionType == unionIndex, off];
    }
  }, {
    key: "getUint8ArrayIteratorInOffset",
    value: function getUint8ArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeUint8Array];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeUint8Array);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeUint8, this);
    }
  }, {
    key: "getUint8ArrayIterator",
    value: function getUint8ArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeUint8, this);
      }

      var off = this.offsets[fieldNum];
      return this.getUint8ArrayIteratorInOffset(off);
    }
  }, {
    key: "getUint16ArrayIteratorInOffset",
    value: function getUint16ArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeUint32Array];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeUint16Array);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeUint16, this);
    }
  }, {
    key: "getUint16ArrayIterator",
    value: function getUint16ArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeUint16, this);
      }

      var off = this.offsets[fieldNum];
      return this.getUint16ArrayIteratorInOffset(off);
    }
  }, {
    key: "getUint32ArrayIteratorInOffset",
    value: function getUint32ArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeUint32Array];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeUint32Array);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeUint32, this);
    }
  }, {
    key: "getUint32ArrayIterator",
    value: function getUint32ArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeUint32, this);
      }

      var off = this.offsets[fieldNum];
      return this.getUint32ArrayIteratorInOffset(off);
    }
  }, {
    key: "getUint64ArrayIteratorInOffset",
    value: function getUint64ArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeUint64Array];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeUint64Array);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeUint64, this);
    }
  }, {
    key: "getUint64ArrayIterator",
    value: function getUint64ArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeUint64, this);
      }

      var off = this.offsets[fieldNum];
      return this.getUint64ArrayIteratorInOffset(off);
    }
  }, {
    key: "getMessageArrayIteratorInOffset",
    value: function getMessageArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeMessageArray];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeMessageArray);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeMessage, this);
    }
  }, {
    key: "getMessageArrayIterator",
    value: function getMessageArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeMessage, this);
      }

      var off = this.offsets[fieldNum];
      return this.getMessageArrayIteratorInOffset(off);
    }
  }, {
    key: "getBytesArrayIteratorInOffset",
    value: function getBytesArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeMessageArray];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeBytesArray);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeBytes, this);
    }
  }, {
    key: "getBytesArrayIterator",
    value: function getBytesArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeBytes, this);
      }

      var off = this.offsets[fieldNum];
      return this.getBytesArrayIteratorInOffset(off);
    }
  }, {
    key: "getStringArrayIteratorInOffset",
    value: function getStringArrayIteratorInOffset(off) {
      var contentSize = this.dataView.getUint32(off, true);
      off += FieldSizes[FieldTypes.TypeStringArray];
      off = alignDynamicFieldContentOffset(off, FieldTypes.TypeStringArray);
      return new ArrayIterator(off, off + contentSize, FieldTypes.TypeString, this);
    }
  }, {
    key: "getStringArrayIterator",
    value: function getStringArrayIterator(fieldNum) {
      if (!this.lazyCalcOffsets() || fieldNum >= Object.keys(this.offsets).length) {
        return new ArrayIterator(0, 0, FieldTypes.TypeString, this);
      }

      var off = this.offsets[fieldNum];
      return this.getStringArrayIteratorInOffset(off);
    }
  }]);

  return InternalMessage;
}();

var InternalBuilder =
/*#__PURE__*/
function () {
  function InternalBuilder() {
    _classCallCheck(this, InternalBuilder);

    this.size = 0;
  }

  _createClass(InternalBuilder, [{
    key: "reset",
    value: function reset() {
      this.size = 0;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.size;
    }
  }, {
    key: "writeUint8",
    value: function writeUint8(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint8);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint8(this.size, v);
      }

      this.size += FieldSizes[FieldTypes.TypeUint8];
    }
  }, {
    key: "writeUint16",
    value: function writeUint16(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint16);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint16(this.size, v, true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint16];
    }
  }, {
    key: "writeUint32",
    value: function writeUint32(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint32);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(this.size, v, true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint32];
    }
  }, {
    key: "writeUint64",
    value: function writeUint64(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint64);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setBigUint64(this.size, v, true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint64];
    }
  }, {
    key: "writeBytes",
    value: function writeBytes(buf, v) {
      var dataView = buf ? new DataView(buf.buffer, buf.byteOffset) : undefined;
      this.size = alignOffsetToType(this.size, FieldTypes.TypeBytes);

      if (buf) {
        if (v) {
          dataView.setUint32(this.size, v.byteLength, true);
        } else {
          dataView.setUint32(this.size, 0, true);
        }
      }

      this.size += FieldSizes[FieldTypes.TypeBytes];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeBytes);

      if (v) {
        if (buf) {
          buf.set(v, this.size);
        }

        this.size += v.byteLength;
      }
    }
  }, {
    key: "writeString",
    value: function writeString(buf, v) {
      this.writeBytes(buf, getTextEncoder().encode(v));
    }
  }, {
    key: "writeUnionIndex",
    value: function writeUnionIndex(buf, unionIndex) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUnion);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint16(this.size, unionIndex, true);
      }

      this.size += FieldSizes[FieldTypes.TypeUnion];
    }
  }, {
    key: "writeUint8Array",
    value: function writeUint8Array(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint8Array);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(this.size, v.length * FieldSizes[FieldTypes.TypeUint8], true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint8Array];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeUint8Array);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var vv = _step.value;
          this.writeUint8(buf, vv);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "writeUint16Array",
    value: function writeUint16Array(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint16Array);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(this.size, v.length * FieldSizes[FieldTypes.TypeUint16], true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint16Array];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeUint16Array);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = v[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var vv = _step2.value;
          this.writeUint16(buf, vv);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "writeUint32Array",
    value: function writeUint32Array(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint32Array);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(this.size, v.length * FieldSizes[FieldTypes.TypeUint32], true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint32Array];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeUint32Array);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = v[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var vv = _step3.value;
          this.writeUint32(buf, vv);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "writeUint64Array",
    value: function writeUint64Array(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeUint64Array);

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(this.size, v.length * FieldSizes[FieldTypes.TypeUint64], true);
      }

      this.size += FieldSizes[FieldTypes.TypeUint64Array];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeUint64Array);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = v[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var vv = _step4.value;
          this.writeUint64(buf, vv);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: "writeBytesArray",
    value: function writeBytesArray(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeBytesArray);
      var sizePlaceholderOffset = this.size;
      this.size += FieldSizes[FieldTypes.TypeBytesArray];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeBytesArray);
      var contentSizeStartOffset = this.size;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = v[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var vv = _step5.value;
          this.writeBytes(buf, vv);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var contentSize = this.size - contentSizeStartOffset;

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(sizePlaceholderOffset, contentSize, true);
      }
    }
  }, {
    key: "writeStringArray",
    value: function writeStringArray(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeStringArray);
      var sizePlaceholderOffset = this.size;
      this.size += FieldSizes[FieldTypes.TypeStringArray];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeStringArray);
      var contentSizeStartOffset = this.size;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = v[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var vv = _step6.value;
          this.writeString(buf, vv);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var contentSize = this.size - contentSizeStartOffset;

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(sizePlaceholderOffset, contentSize, true);
      }
    }
  }, {
    key: "writeMessage",
    value: function writeMessage(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeMessage);
      var sizePlaceholderOffset = this.size;
      this.size += FieldSizes[FieldTypes.TypeMessage];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeMessage);

      if (buf) {
        v.write(buf.subarray(this.size));
      } else {
        v.write(null);
      }

      var contentSize = v.getSize();
      this.size += contentSize;

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(sizePlaceholderOffset, contentSize, true);
      }
    }
  }, {
    key: "writeMessageArray",
    value: function writeMessageArray(buf, v) {
      this.size = alignOffsetToType(this.size, FieldTypes.TypeMessageArray);
      var sizePlaceholderOffset = this.size;
      this.size += FieldSizes[FieldTypes.TypeMessageArray];
      this.size = alignDynamicFieldContentOffset(this.size, FieldTypes.TypeMessageArray);
      var contentSizeStartOffset = this.size;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = v[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var vv = _step7.value;
          this.writeMessage(buf, vv);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var contentSize = this.size - contentSizeStartOffset;

      if (buf) {
        new DataView(buf.buffer, buf.byteOffset).setUint32(sizePlaceholderOffset, contentSize, true);
      }
    }
  }]);

  return InternalBuilder;
}();

var BaseBuilder =
/*#__PURE__*/
function () {
  function BaseBuilder() {
    _classCallCheck(this, BaseBuilder);

    this.builder = new InternalBuilder();
  }

  _createClass(BaseBuilder, [{
    key: "getSize",
    value: function getSize() {
      return this.builder.getSize();
    }
  }, {
    key: "calcRequiredSize",
    value: function calcRequiredSize() {
      this.write(null);
      return this.builder.getSize();
    }
  }, {
    key: "build",
    value: function build() {
      var buf = new Uint8Array(this.calcRequiredSize());
      this.write(buf);
      return buf;
    }
  }]);

  return BaseBuilder;
}();

var RequestResult_Scheme = [FieldTypes.TypeUint16, FieldTypes.TypeUint64, FieldTypes.TypeUint64];

var TransactionRefBuilder =
/*#__PURE__*/
function (_BaseBuilder) {
  _inherits(TransactionRefBuilder, _BaseBuilder);

  function TransactionRefBuilder(fields) {
    var _this2;

    _classCallCheck(this, TransactionRefBuilder);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionRefBuilder).call(this));
    _this2.fields = fields;
    return _this2;
  }

  _createClass(TransactionRefBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUint32(buf, this.fields.protocolVersion);
      this.builder.writeUint32(buf, this.fields.virtualChainId);
      this.builder.writeUint64(buf, this.fields.transactionTimestamp);
      this.builder.writeBytes(buf, this.fields.txHash);
    }
  }]);

  return TransactionRefBuilder;
}(BaseBuilder);

var SendTransactionRequest_Scheme = [FieldTypes.TypeMessage];

var SendTransactionRequestBuilder =
/*#__PURE__*/
function (_BaseBuilder2) {
  _inherits(SendTransactionRequestBuilder, _BaseBuilder2);

  function SendTransactionRequestBuilder(fields) {
    var _this3;

    _classCallCheck(this, SendTransactionRequestBuilder);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SendTransactionRequestBuilder).call(this));
    _this3.fields = fields;
    return _this3;
  }

  _createClass(SendTransactionRequestBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.signedTransaction);
    }
  }]);

  return SendTransactionRequestBuilder;
}(BaseBuilder);

var SendTransactionResponse_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeUint16, FieldTypes.TypeMessage];

var RunQueryRequestBuilder =
/*#__PURE__*/
function (_BaseBuilder3) {
  _inherits(RunQueryRequestBuilder, _BaseBuilder3);

  function RunQueryRequestBuilder(fields) {
    var _this4;

    _classCallCheck(this, RunQueryRequestBuilder);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(RunQueryRequestBuilder).call(this));
    _this4.fields = fields;
    return _this4;
  }

  _createClass(RunQueryRequestBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.signedQuery);
    }
  }]);

  return RunQueryRequestBuilder;
}(BaseBuilder);

var RunQueryResponse_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeMessage];

var GetTransactionStatusRequestBuilder =
/*#__PURE__*/
function (_BaseBuilder4) {
  _inherits(GetTransactionStatusRequestBuilder, _BaseBuilder4);

  function GetTransactionStatusRequestBuilder(fields) {
    var _this5;

    _classCallCheck(this, GetTransactionStatusRequestBuilder);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(GetTransactionStatusRequestBuilder).call(this));
    _this5.fields = fields;
    return _this5;
  }

  _createClass(GetTransactionStatusRequestBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.transactionRef);
    }
  }]);

  return GetTransactionStatusRequestBuilder;
}(BaseBuilder);

var GetTransactionStatusResponse_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeUint16, FieldTypes.TypeMessage];

var GetTransactionReceiptProofRequestBuilder =
/*#__PURE__*/
function (_BaseBuilder5) {
  _inherits(GetTransactionReceiptProofRequestBuilder, _BaseBuilder5);

  function GetTransactionReceiptProofRequestBuilder(fields) {
    var _this6;

    _classCallCheck(this, GetTransactionReceiptProofRequestBuilder);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(GetTransactionReceiptProofRequestBuilder).call(this));
    _this6.fields = fields;
    return _this6;
  }

  _createClass(GetTransactionReceiptProofRequestBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.transactionRef);
    }
  }]);

  return GetTransactionReceiptProofRequestBuilder;
}(BaseBuilder);

var GetTransactionReceiptProofResponse_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeUint16, FieldTypes.TypeMessage, FieldTypes.TypeBytes];

var GetBlockRequestBuilder =
/*#__PURE__*/
function (_BaseBuilder6) {
  _inherits(GetBlockRequestBuilder, _BaseBuilder6);

  function GetBlockRequestBuilder(fields) {
    var _this7;

    _classCallCheck(this, GetBlockRequestBuilder);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(GetBlockRequestBuilder).call(this));
    _this7.fields = fields;
    return _this7;
  }

  _createClass(GetBlockRequestBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUint32(buf, this.fields.protocolVersion);
      this.builder.writeUint32(buf, this.fields.virtualChainId);
      this.builder.writeUint64(buf, this.fields.blockHeight);
    }
  }]);

  return GetBlockRequestBuilder;
}(BaseBuilder);

var GetBlockResponse_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeMessage, FieldTypes.TypeMessage, FieldTypes.TypeMessageArray, FieldTypes.TypeMessage, FieldTypes.TypeMessage, FieldTypes.TypeMessageArray, FieldTypes.TypeMessageArray, FieldTypes.TypeMessage];

function dateToUnixNano(date) {
  return BigInt(date.getTime()) * BigInt(1000000);
}

function unixNanoToDate(timestamp) {
  return new Date(Number(timestamp / BigInt(1000000)));
}

var Argument_Scheme = [FieldTypes.TypeUnion];
var Argument_Unions = [[FieldTypes.TypeUint32, FieldTypes.TypeUint64, FieldTypes.TypeString, FieldTypes.TypeBytes]];

var ArgumentBuilder =
/*#__PURE__*/
function (_BaseBuilder7) {
  _inherits(ArgumentBuilder, _BaseBuilder7);

  function ArgumentBuilder(fields) {
    var _this8;

    _classCallCheck(this, ArgumentBuilder);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ArgumentBuilder).call(this));
    _this8.fields = fields;
    return _this8;
  }

  _createClass(ArgumentBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUnionIndex(buf, this.fields.type);

      switch (this.fields.type) {
        case 0:
          this.builder.writeUint32(buf, this.fields.value);
          break;

        case 1:
          this.builder.writeUint64(buf, this.fields.value);
          break;

        case 2:
          this.builder.writeString(buf, this.fields.value);
          break;

        case 3:
          this.builder.writeBytes(buf, this.fields.value);
          break;

        default:
          throw new Error("unknown Argument type ".concat(this.fields.type));
      }
    }
  }]);

  return ArgumentBuilder;
}(BaseBuilder);

var ArgumentArray_Scheme = [FieldTypes.TypeMessageArray];

var ArgumentArrayBuilder =
/*#__PURE__*/
function (_BaseBuilder8) {
  _inherits(ArgumentArrayBuilder, _BaseBuilder8);

  function ArgumentArrayBuilder(fields) {
    var _this9;

    _classCallCheck(this, ArgumentArrayBuilder);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(ArgumentArrayBuilder).call(this));
    _this9.fields = fields;
    return _this9;
  }

  _createClass(ArgumentArrayBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessageArray(buf, this.fields.arguments);
    }
  }]);

  return ArgumentArrayBuilder;
}(BaseBuilder);

var Event_Scheme = [FieldTypes.TypeString, FieldTypes.TypeString, FieldTypes.TypeBytes];
var EventsArray_Scheme = [FieldTypes.TypeMessageArray];

var EdDSA01SignerBuilder =
/*#__PURE__*/
function (_BaseBuilder9) {
  _inherits(EdDSA01SignerBuilder, _BaseBuilder9);

  function EdDSA01SignerBuilder(fields) {
    var _this10;

    _classCallCheck(this, EdDSA01SignerBuilder);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(EdDSA01SignerBuilder).call(this));
    _this10.fields = fields;
    return _this10;
  }

  _createClass(EdDSA01SignerBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUint16(buf, this.fields.networkType);
      this.builder.writeBytes(buf, this.fields.signerPublicKey);
    }
  }]);

  return EdDSA01SignerBuilder;
}(BaseBuilder);

var SignerBuilder =
/*#__PURE__*/
function (_BaseBuilder10) {
  _inherits(SignerBuilder, _BaseBuilder10);

  function SignerBuilder(fields) {
    var _this11;

    _classCallCheck(this, SignerBuilder);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(SignerBuilder).call(this));
    _this11.fields = fields;
    return _this11;
  }

  _createClass(SignerBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUnionIndex(buf, this.fields.scheme);

      switch (this.fields.scheme) {
        case 0:
          this.builder.writeMessage(buf, this.fields.eddsa);
          break;

        default:
          throw new Error("unknown Signer scheme ".concat(this.fields.scheme));
      }
    }
  }]);

  return SignerBuilder;
}(BaseBuilder);

var Signer_Scheme = [FieldTypes.TypeUnion];
var Signer_Unions = [[FieldTypes.TypeMessage, FieldTypes.TypeMessage]];
var EdDSA01Signer_Scheme = [FieldTypes.TypeUint16, FieldTypes.TypeBytes];

var TransactionBuilder =
/*#__PURE__*/
function (_BaseBuilder11) {
  _inherits(TransactionBuilder, _BaseBuilder11);

  function TransactionBuilder(fields) {
    var _this12;

    _classCallCheck(this, TransactionBuilder);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionBuilder).call(this));
    _this12.fields = fields;
    return _this12;
  }

  _createClass(TransactionBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUint32(buf, this.fields.protocolVersion);
      this.builder.writeUint32(buf, this.fields.virtualChainId);
      this.builder.writeUint64(buf, this.fields.timestamp);
      this.builder.writeMessage(buf, this.fields.signer);
      this.builder.writeString(buf, this.fields.contractName);
      this.builder.writeString(buf, this.fields.methodName);
      this.builder.writeBytes(buf, this.fields.inputArgumentArray);
    }
  }]);

  return TransactionBuilder;
}(BaseBuilder);

var Transaction_Scheme = [FieldTypes.TypeUint32, FieldTypes.TypeUint32, FieldTypes.TypeUint64, FieldTypes.TypeMessage, FieldTypes.TypeString, FieldTypes.TypeString, FieldTypes.TypeBytes];
var SignedTransaction_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeBytes];

var SignedTransactionBuilder =
/*#__PURE__*/
function (_BaseBuilder12) {
  _inherits(SignedTransactionBuilder, _BaseBuilder12);

  function SignedTransactionBuilder(fields) {
    var _this13;

    _classCallCheck(this, SignedTransactionBuilder);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(SignedTransactionBuilder).call(this));
    _this13.fields = fields;
    return _this13;
  }

  _createClass(SignedTransactionBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.transaction);
      this.builder.writeBytes(buf, this.fields.signature);
    }
  }]);

  return SignedTransactionBuilder;
}(BaseBuilder);

var TransactionReceipt_Scheme = [FieldTypes.TypeBytes, FieldTypes.TypeUint16, FieldTypes.TypeBytes, FieldTypes.TypeBytes];

var QueryBuilder =
/*#__PURE__*/
function (_BaseBuilder13) {
  _inherits(QueryBuilder, _BaseBuilder13);

  function QueryBuilder(fields) {
    var _this14;

    _classCallCheck(this, QueryBuilder);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(QueryBuilder).call(this));
    _this14.fields = fields;
    return _this14;
  }

  _createClass(QueryBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeUint32(buf, this.fields.protocolVersion);
      this.builder.writeUint32(buf, this.fields.virtualChainId);
      this.builder.writeUint64(buf, this.fields.timestamp);
      this.builder.writeMessage(buf, this.fields.signer);
      this.builder.writeString(buf, this.fields.contractName);
      this.builder.writeString(buf, this.fields.methodName);
      this.builder.writeBytes(buf, this.fields.inputArgumentArray);
    }
  }]);

  return QueryBuilder;
}(BaseBuilder);

var SignedQuery_Scheme = [FieldTypes.TypeMessage, FieldTypes.TypeBytes];

var SignedQueryBuilder =
/*#__PURE__*/
function (_BaseBuilder14) {
  _inherits(SignedQueryBuilder, _BaseBuilder14);

  function SignedQueryBuilder(fields) {
    var _this15;

    _classCallCheck(this, SignedQueryBuilder);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(SignedQueryBuilder).call(this));
    _this15.fields = fields;
    return _this15;
  }

  _createClass(SignedQueryBuilder, [{
    key: "write",
    value: function write(buf) {
      this.builder.reset();
      this.builder.writeMessage(buf, this.fields.query);
      this.builder.writeBytes(buf, this.fields.signature);
    }
  }]);

  return SignedQueryBuilder;
}(BaseBuilder);

var QueryResult_Scheme = [FieldTypes.TypeUint16, FieldTypes.TypeBytes, FieldTypes.TypeBytes];
var TransactionsBlockHeader_Scheme = [FieldTypes.TypeUint32, FieldTypes.TypeUint32, FieldTypes.TypeUint64, FieldTypes.TypeBytes, FieldTypes.TypeUint64, FieldTypes.TypeBytes, FieldTypes.TypeBytes, FieldTypes.TypeUint32];
var ResultsBlockHeader_Scheme = [FieldTypes.TypeUint32, FieldTypes.TypeUint32, FieldTypes.TypeUint64, FieldTypes.TypeBytes, FieldTypes.TypeUint64, FieldTypes.TypeBytes, FieldTypes.TypeBytes, FieldTypes.TypeBytes, FieldTypes.TypeBytes, FieldTypes.TypeUint32, FieldTypes.TypeUint32];
var ED25519_SIGNATURE_SIZE_BYTES = 64;

function signEd25519(privateKey, data) {
  if (privateKey.byteLength != ED25519_PRIVATE_KEY_SIZE_BYTES) {
    throw new Error("cannot sign with ed25519, private key invalid with length ".concat(privateKey.byteLength));
  }

  var ec = new elliptic.eddsa("ed25519");
  var privateKeyString = uint8ArrayToHexString$1(privateKey.subarray(0, ED25519_PRIVATE_KEY_SIZE_BYTES - ED25519_PUBLIC_KEY_SIZE_BYTES));
  var key = ec.keyFromSecret(privateKeyString); // console.log(key.getPublic("hex"));
  // console.log(key.getSecret("hex"));

  return new Uint8Array(key.sign(data).toBytes());
}

function uint8ArrayToHexString$1(arr) {
  return Array.prototype.map.call(arr, function (x) {
    return ("00" + x.toString(16)).slice(-2);
  }).join("");
}

var argUint32$$1 = function argUint32$$1(value) {
  return {
    type: "uint32",
    value: value
  };
};

var argUint64$$1 = function argUint64$$1(value) {
  return {
    type: "uint64",
    value: typeof value === "number" ? BigInt(value) : value
  };
};

var argString$$1 = function argString$$1(value) {
  return {
    type: "string",
    value: value
  };
};

var argBytes$$1 = function argBytes$$1(value) {
  return {
    type: "bytes",
    value: value
  };
};

var argAddress$$1 = function argAddress$$1(address) {
  return argBytes$$1(addressToBytes(address));
};

function argumentsBuilders(args) {
  var res = [];

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];

    switch (arg.type) {
      case "uint32":
        res.push(new ArgumentBuilder({
          type: 0,
          value: arg.value
        }));
        break;

      case "uint64":
        res.push(new ArgumentBuilder({
          type: 1,
          value: arg.value
        }));
        break;

      case "string":
        res.push(new ArgumentBuilder({
          type: 2,
          value: arg.value
        }));
        break;

      case "bytes":
        res.push(new ArgumentBuilder({
          type: 3,
          value: arg.value
        }));
        break;

      default:
        throw new Error("Argument unknown type: ".concat(arg));
    }
  }

  return res;
}

function argumentsArray(args) {
  var builders = argumentsBuilders(args);
  var buf = new ArgumentArrayBuilder({
    arguments: builders
  }).build();
  return new InternalMessage(buf, buf.byteLength, ArgumentArray_Scheme, []);
}

function packedArgumentsEncode(args) {
  var msg = argumentsArray(args);
  return msg.rawBufferForField(0, 0);
}

function packedArgumentsDecode(buf) {
  var res = [];
  var argsArrayMsg = new InternalMessage(buf, buf.byteLength, ArgumentArray_Scheme, []);
  var iterator = argsArrayMsg.getMessageArrayIterator(0);
  var index = 0;

  while (iterator.hasNext()) {
    var _iterator$nextMessage = iterator.nextMessage(),
        _iterator$nextMessage2 = _slicedToArray(_iterator$nextMessage, 2),
        argumentBuf = _iterator$nextMessage2[0],
        argumentBufLength = _iterator$nextMessage2[1];

    var argumentMsg = new InternalMessage(argumentBuf, argumentBufLength, Argument_Scheme, Argument_Unions);
    var type = argumentMsg.getUnionIndex(0, 0);

    switch (type) {
      case 0:
        var _argumentMsg$isUnionI = argumentMsg.isUnionIndex(0, 0, 0),
            _argumentMsg$isUnionI2 = _slicedToArray(_argumentMsg$isUnionI, 2),
            uint32Off = _argumentMsg$isUnionI2[1];

        res.push(argUint32$$1(argumentMsg.getUint32InOffset(uint32Off)));
        break;

      case 1:
        var _argumentMsg$isUnionI3 = argumentMsg.isUnionIndex(0, 0, 1),
            _argumentMsg$isUnionI4 = _slicedToArray(_argumentMsg$isUnionI3, 2),
            uint64Off = _argumentMsg$isUnionI4[1];

        res.push(argUint64$$1(argumentMsg.getUint64InOffset(uint64Off)));
        break;

      case 2:
        var _argumentMsg$isUnionI5 = argumentMsg.isUnionIndex(0, 0, 2),
            _argumentMsg$isUnionI6 = _slicedToArray(_argumentMsg$isUnionI5, 2),
            stringOff = _argumentMsg$isUnionI6[1];

        res.push(argString$$1(argumentMsg.getStringInOffset(stringOff)));
        break;

      case 3:
        var _argumentMsg$isUnionI7 = argumentMsg.isUnionIndex(0, 0, 3),
            _argumentMsg$isUnionI8 = _slicedToArray(_argumentMsg$isUnionI7, 2),
            bytesOff = _argumentMsg$isUnionI8[1];

        res.push(argBytes$$1(argumentMsg.getBytesInOffset(bytesOff)));
        break;

      default:
        throw new Error("received argument ".concat(index, " has unknown type: ").concat(type));
    }

    index++;
  }

  return res;
}

function packedEventsDecode(buf) {
  var res = [];
  var eventsArrayMsg = new InternalMessage(buf, buf.byteLength, EventsArray_Scheme, []);
  var iterator = eventsArrayMsg.getMessageArrayIterator(0);

  while (iterator.hasNext()) {
    var _iterator$nextMessage3 = iterator.nextMessage(),
        _iterator$nextMessage4 = _slicedToArray(_iterator$nextMessage3, 2),
        eventBuf = _iterator$nextMessage4[0],
        eventBufLength = _iterator$nextMessage4[1];

    var eventMsg = new InternalMessage(eventBuf, eventBufLength, Event_Scheme, []);
    res.push({
      contractName: eventMsg.getString(0),
      eventName: eventMsg.getString(1),
      arguments: packedArgumentsDecode(eventMsg.rawBufferWithHeaderForField(2, 0))
    });
  }

  return res;
}

var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["TRANSACTION_STATUS_COMMITTED"] = "COMMITTED";
  TransactionStatus["TRANSACTION_STATUS_DUPLICATE_TRANSACTION_ALREADY_COMMITTED"] = "DUPLICATE_TRANSACTION_ALREADY_COMMITTED";
  TransactionStatus["TRANSACTION_STATUS_PENDING"] = "PENDING";
  TransactionStatus["TRANSACTION_STATUS_DUPLICATE_TRANSACTION_ALREADY_PENDING"] = "DUPLICATE_TRANSACTION_ALREADY_PENDING";
  TransactionStatus["TRANSACTION_STATUS_NO_RECORD_FOUND"] = "NO_RECORD_FOUND";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_UNSUPPORTED_VERSION"] = "REJECTED_UNSUPPORTED_VERSION";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_VIRTUAL_CHAIN_MISMATCH"] = "REJECTED_VIRTUAL_CHAIN_MISMATCH";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_TIMESTAMP_WINDOW_EXCEEDED"] = "REJECTED_TIMESTAMP_WINDOW_EXCEEDED";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_SIGNATURE_MISMATCH"] = "REJECTED_SIGNATURE_MISMATCH";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_UNKNOWN_SIGNER_SCHEME"] = "REJECTED_UNKNOWN_SIGNER_SCHEME";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_GLOBAL_PRE_ORDER"] = "REJECTED_GLOBAL_PRE_ORDER";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_VIRTUAL_CHAIN_PRE_ORDER"] = "REJECTED_VIRTUAL_CHAIN_PRE_ORDER";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_SMART_CONTRACT_PRE_ORDER"] = "REJECTED_SMART_CONTRACT_PRE_ORDER";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_TIMESTAMP_AHEAD_OF_NODE_TIME"] = "REJECTED_TIMESTAMP_AHEAD_OF_NODE_TIME";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_CONGESTION"] = "REJECTED_CONGESTION";
  TransactionStatus["TRANSACTION_STATUS_REJECTED_NODE_OUT_OF_SYNC"] = "REJECTED_NODE_OUT_OF_SYNC";
})(TransactionStatus || (TransactionStatus = {}));

function transactionStatusDecode(transactionStatus) {
  switch (transactionStatus) {
    case 0:
      throw new Error("reserved TransactionStatus received");

    case 1:
      return TransactionStatus.TRANSACTION_STATUS_COMMITTED;

    case 2:
      return TransactionStatus.TRANSACTION_STATUS_DUPLICATE_TRANSACTION_ALREADY_COMMITTED;

    case 3:
      return TransactionStatus.TRANSACTION_STATUS_PENDING;

    case 4:
      return TransactionStatus.TRANSACTION_STATUS_DUPLICATE_TRANSACTION_ALREADY_PENDING;

    case 6:
      return TransactionStatus.TRANSACTION_STATUS_NO_RECORD_FOUND;

    case 7:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_UNSUPPORTED_VERSION;

    case 8:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_VIRTUAL_CHAIN_MISMATCH;

    case 9:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_TIMESTAMP_WINDOW_EXCEEDED;

    case 10:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_SIGNATURE_MISMATCH;

    case 11:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_UNKNOWN_SIGNER_SCHEME;

    case 12:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_GLOBAL_PRE_ORDER;

    case 13:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_VIRTUAL_CHAIN_PRE_ORDER;

    case 14:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_SMART_CONTRACT_PRE_ORDER;

    case 15:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_TIMESTAMP_AHEAD_OF_NODE_TIME;

    case 16:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_CONGESTION;

    case 17:
      return TransactionStatus.TRANSACTION_STATUS_REJECTED_NODE_OUT_OF_SYNC;

    default:
      throw new Error("unsupported TransactionStatus received: ".concat(transactionStatus));
  }
}

function encodeSendTransactionRequest(req, privateKey) {
  // validate
  if (req.protocolVersion != 1) {
    throw new Error("expected ProtocolVersion 1, ".concat(req.protocolVersion, " given"));
  }

  if (req.publicKey.byteLength != ED25519_PUBLIC_KEY_SIZE_BYTES) {
    throw new Error("expected PublicKey length ".concat(ED25519_PUBLIC_KEY_SIZE_BYTES, ", ").concat(req.publicKey.byteLength, " given"));
  }

  if (privateKey.byteLength != ED25519_PRIVATE_KEY_SIZE_BYTES) {
    throw new Error("expected PublicKey length ".concat(ED25519_PRIVATE_KEY_SIZE_BYTES, ", ").concat(privateKey.byteLength, " given"));
  } // encode method arguments


  var inputArgumentArray = packedArgumentsEncode(req.inputArguments); // encode network type

  var networkType = networkTypeEncode(req.networkType); // encode timestamp

  var timestampNano = dateToUnixNano(req.timestamp); // encode request

  var res = new SendTransactionRequestBuilder({
    signedTransaction: new SignedTransactionBuilder({
      transaction: new TransactionBuilder({
        protocolVersion: req.protocolVersion,
        virtualChainId: req.virtualChainId,
        timestamp: timestampNano,
        signer: new SignerBuilder({
          scheme: 0,
          eddsa: new EdDSA01SignerBuilder({
            networkType: networkType,
            signerPublicKey: req.publicKey
          })
        }),
        contractName: req.contractName,
        methodName: req.methodName,
        inputArgumentArray: inputArgumentArray
      }),
      signature: new Uint8Array(ED25519_SIGNATURE_SIZE_BYTES)
    })
  }); // read encoded bytes

  var buf = res.build();
  var sendTransactionRequestMsg = new InternalMessage(buf, buf.byteLength, SendTransactionRequest_Scheme, []);
  var signedTransactionBuf = sendTransactionRequestMsg.getMessage(0);
  var signedTransactionMsg = new InternalMessage(signedTransactionBuf, signedTransactionBuf.byteLength, SignedTransaction_Scheme, []);
  var transactionBuf = signedTransactionMsg.rawBufferForField(0, 0); // sign

  var txHash = calcTxHash(transactionBuf);
  var sig = signEd25519(privateKey, txHash);
  signedTransactionMsg.setBytes(1, sig); // return

  return [buf, generateTxId(txHash, timestampNano)];
}

function decodeSendTransactionResponse(buf) {
  // decode response
  var sendTransactionResponseMsg = new InternalMessage(buf, buf.byteLength, SendTransactionResponse_Scheme, []);

  if (!sendTransactionResponseMsg.isValid()) {
    throw new Error("response is corrupt and cannot be decoded");
  } // decode request status


  var requestResultBuf = sendTransactionResponseMsg.getMessage(0);
  var requestResultMsg = new InternalMessage(requestResultBuf, requestResultBuf.byteLength, RequestResult_Scheme, []);
  var requestStatus = requestStatusDecode(requestResultMsg.getUint16(0)); // decode execution result

  var transactionReceiptBuf = sendTransactionResponseMsg.getMessage(2);
  var transactionReceiptMsg = new InternalMessage(transactionReceiptBuf, transactionReceiptBuf.byteLength, TransactionReceipt_Scheme, []);
  var executionResult = ExecutionResult.EXECUTION_RESULT_NOT_EXECUTED;

  if (transactionReceiptBuf.byteLength > 0) {
    executionResult = executionResultDecode(transactionReceiptMsg.getUint16(1));
  } // decode method arguments


  var outputArgumentArray = packedArgumentsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(2, 0)); // decode events

  var outputEventArray = packedEventsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(3, 0)); // decode transaction status

  var transactionStatus = transactionStatusDecode(sendTransactionResponseMsg.getUint16(1)); // return

  return {
    requestStatus: requestStatus,
    txHash: transactionReceiptMsg.getBytes(0),
    executionResult: executionResult,
    outputArguments: outputArgumentArray,
    outputEvents: outputEventArray,
    transactionStatus: transactionStatus,
    blockHeight: requestResultMsg.getUint64(1),
    blockTimestamp: unixNanoToDate(requestResultMsg.getUint64(2))
  };
}

function encodeRunQueryRequest(req) {
  // validate
  if (req.protocolVersion != 1) {
    throw new Error("expected ProtocolVersion 1, ".concat(req.protocolVersion, " given"));
  }

  if (req.publicKey.byteLength != ED25519_PUBLIC_KEY_SIZE_BYTES) {
    throw new Error("expected PublicKey length ".concat(ED25519_PUBLIC_KEY_SIZE_BYTES, ", ").concat(req.publicKey.byteLength, " given"));
  } // encode method arguments


  var inputArgumentArray = packedArgumentsEncode(req.inputArguments); // encode network type

  var networkType = networkTypeEncode(req.networkType); // encode request

  var res = new RunQueryRequestBuilder({
    signedQuery: new SignedQueryBuilder({
      query: new QueryBuilder({
        protocolVersion: req.protocolVersion,
        virtualChainId: req.virtualChainId,
        timestamp: dateToUnixNano(req.timestamp),
        signer: new SignerBuilder({
          scheme: 0,
          eddsa: new EdDSA01SignerBuilder({
            networkType: networkType,
            signerPublicKey: req.publicKey
          })
        }),
        contractName: req.contractName,
        methodName: req.methodName,
        inputArgumentArray: inputArgumentArray
      }),
      signature: null
    })
  }); // return

  return res.build();
}

function decodeRunQueryResponse(buf) {
  // decode response
  var runQueryResponseMsg = new InternalMessage(buf, buf.byteLength, RunQueryResponse_Scheme, []);

  if (!runQueryResponseMsg.isValid()) {
    throw new Error("response is corrupt and cannot be decoded");
  } // decode request status


  var requestResultBuf = runQueryResponseMsg.getMessage(0);
  var requestResultMsg = new InternalMessage(requestResultBuf, requestResultBuf.byteLength, RequestResult_Scheme, []);
  var requestStatus = requestStatusDecode(requestResultMsg.getUint16(0)); // decode execution result

  var queryResultBuf = runQueryResponseMsg.getMessage(1);
  var queryResultMsg = new InternalMessage(queryResultBuf, queryResultBuf.byteLength, QueryResult_Scheme, []);
  var executionResult = ExecutionResult.EXECUTION_RESULT_NOT_EXECUTED;

  if (queryResultBuf.byteLength > 0) {
    executionResult = executionResultDecode(queryResultMsg.getUint16(0));
  } // decode method arguments


  var outputArgumentArray = packedArgumentsDecode(queryResultMsg.rawBufferWithHeaderForField(1, 0)); // decode events

  var outputEventArray = packedEventsDecode(queryResultMsg.rawBufferWithHeaderForField(2, 0)); // return

  return {
    requestStatus: requestStatus,
    executionResult: executionResult,
    outputArguments: outputArgumentArray,
    outputEvents: outputEventArray,
    blockHeight: requestResultMsg.getUint64(1),
    blockTimestamp: unixNanoToDate(requestResultMsg.getUint64(2))
  };
}

function encodeGetTransactionStatusRequest(req) {
  // validate
  if (req.protocolVersion != 1) {
    throw new Error("expected ProtocolVersion 1, ".concat(req.protocolVersion, " given"));
  }

  if (req.txId.byteLength != TX_ID_SIZE_BYTES) {
    throw new Error("expected TxId length ".concat(TX_ID_SIZE_BYTES, ", ").concat(req.txId.byteLength, " given"));
  } // extract txid


  var _extractTxId = extractTxId(req.txId),
      _extractTxId2 = _slicedToArray(_extractTxId, 2),
      txHash = _extractTxId2[0],
      txTimestamp = _extractTxId2[1]; // encode request


  var res = new GetTransactionStatusRequestBuilder({
    transactionRef: new TransactionRefBuilder({
      protocolVersion: req.protocolVersion,
      virtualChainId: req.virtualChainId,
      transactionTimestamp: txTimestamp,
      txHash: txHash
    })
  }); // return

  return res.build();
}

function decodeGetTransactionStatusResponse(buf) {
  // decode response
  var getTransactionStatusResponseMsg = new InternalMessage(buf, buf.byteLength, GetTransactionStatusResponse_Scheme, []);

  if (!getTransactionStatusResponseMsg.isValid()) {
    throw new Error("response is corrupt and cannot be decoded");
  } // decode request status


  var requestResultBuf = getTransactionStatusResponseMsg.getMessage(0);
  var requestResultMsg = new InternalMessage(requestResultBuf, requestResultBuf.byteLength, RequestResult_Scheme, []);
  var requestStatus = requestStatusDecode(requestResultMsg.getUint16(0)); // decode execution result

  var transactionReceiptBuf = getTransactionStatusResponseMsg.getMessage(2);
  var transactionReceiptMsg = new InternalMessage(transactionReceiptBuf, transactionReceiptBuf.byteLength, TransactionReceipt_Scheme, []);
  var executionResult = ExecutionResult.EXECUTION_RESULT_NOT_EXECUTED;

  if (transactionReceiptBuf.byteLength > 0) {
    executionResult = executionResultDecode(transactionReceiptMsg.getUint16(1));
  } // decode method arguments


  var outputArgumentArray = packedArgumentsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(2, 0)); // decode events

  var outputEventArray = packedEventsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(3, 0)); // decode transaction status

  var transactionStatus = transactionStatusDecode(getTransactionStatusResponseMsg.getUint16(1)); // return

  return {
    requestStatus: requestStatus,
    txHash: transactionReceiptMsg.getBytes(0),
    executionResult: executionResult,
    outputArguments: outputArgumentArray,
    outputEvents: outputEventArray,
    transactionStatus: transactionStatus,
    blockHeight: requestResultMsg.getUint64(1),
    blockTimestamp: unixNanoToDate(requestResultMsg.getUint64(2))
  };
}

function encodeGetTransactionReceiptProofRequest(req) {
  // validate
  if (req.protocolVersion != 1) {
    throw new Error("expected ProtocolVersion 1, ".concat(req.protocolVersion, " given"));
  }

  if (req.txId.byteLength != TX_ID_SIZE_BYTES) {
    throw new Error("expected TxId length ".concat(TX_ID_SIZE_BYTES, ", ").concat(req.txId.byteLength, " given"));
  } // extract txid


  var _extractTxId3 = extractTxId(req.txId),
      _extractTxId4 = _slicedToArray(_extractTxId3, 2),
      txHash = _extractTxId4[0],
      txTimestamp = _extractTxId4[1]; // encode request


  var res = new GetTransactionReceiptProofRequestBuilder({
    transactionRef: new TransactionRefBuilder({
      protocolVersion: req.protocolVersion,
      virtualChainId: req.virtualChainId,
      transactionTimestamp: txTimestamp,
      txHash: txHash
    })
  }); // return

  return res.build();
}

function decodeGetTransactionReceiptProofResponse(buf) {
  // decode response
  var getTransactionReceiptProofResponseMsg = new InternalMessage(buf, buf.byteLength, GetTransactionReceiptProofResponse_Scheme, []);

  if (!getTransactionReceiptProofResponseMsg.isValid()) {
    throw new Error("response is corrupt and cannot be decoded");
  } // decode request status


  var requestResultBuf = getTransactionReceiptProofResponseMsg.getMessage(0);
  var requestResultMsg = new InternalMessage(requestResultBuf, requestResultBuf.byteLength, RequestResult_Scheme, []);
  var requestStatus = requestStatusDecode(requestResultMsg.getUint16(0)); // decode execution result

  var transactionReceiptBuf = getTransactionReceiptProofResponseMsg.getMessage(2);
  var transactionReceiptMsg = new InternalMessage(transactionReceiptBuf, transactionReceiptBuf.byteLength, TransactionReceipt_Scheme, []);
  var executionResult = ExecutionResult.EXECUTION_RESULT_NOT_EXECUTED;

  if (transactionReceiptBuf.byteLength > 0) {
    executionResult = executionResultDecode(transactionReceiptMsg.getUint16(1));
  } // decode method arguments


  var outputArgumentArray = packedArgumentsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(2, 0)); // decode events

  var outputEventArray = packedEventsDecode(transactionReceiptMsg.rawBufferWithHeaderForField(3, 0)); // decode transaction status

  var transactionStatus = transactionStatusDecode(getTransactionReceiptProofResponseMsg.getUint16(1)); // return

  return {
    requestStatus: requestStatus,
    txHash: transactionReceiptMsg.getBytes(0),
    executionResult: executionResult,
    outputArguments: outputArgumentArray,
    outputEvents: outputEventArray,
    transactionStatus: transactionStatus,
    blockHeight: requestResultMsg.getUint64(1),
    blockTimestamp: unixNanoToDate(requestResultMsg.getUint64(2)),
    packedProof: getTransactionReceiptProofResponseMsg.getBytes(3),
    packedReceipt: transactionReceiptBuf
  };
}

function encodeGetBlockRequest(req) {
  // validate
  if (req.protocolVersion != 1) {
    throw new Error("expected ProtocolVersion 1, ".concat(req.protocolVersion, " given"));
  } // encode request


  var res = new GetBlockRequestBuilder({
    protocolVersion: req.protocolVersion,
    virtualChainId: req.virtualChainId,
    blockHeight: req.blockHeight
  }); // return

  return res.build();
}

function decodeGetBlockResponse(buf) {
  // decode response
  var getBlockResponseMsg = new InternalMessage(buf, buf.byteLength, GetBlockResponse_Scheme, []);

  if (!getBlockResponseMsg.isValid()) {
    throw new Error("response is corrupt and cannot be decoded");
  } // decode request status


  var requestResultBuf = getBlockResponseMsg.getMessage(0);
  var requestResultMsg = new InternalMessage(requestResultBuf, requestResultBuf.byteLength, RequestResult_Scheme, []);
  var requestStatus = requestStatusDecode(requestResultMsg.getUint16(0)); // decode transactions block header

  var transactionsBlockHeaderBuf = getBlockResponseMsg.getMessage(1);
  var transactionsBlockHeaderMsg = new InternalMessage(transactionsBlockHeaderBuf, transactionsBlockHeaderBuf.byteLength, TransactionsBlockHeader_Scheme, []); // decode results block header

  var resultsBlockHeaderBuf = getBlockResponseMsg.getMessage(5);
  var resultsBlockHeaderMsg = new InternalMessage(resultsBlockHeaderBuf, resultsBlockHeaderBuf.byteLength, ResultsBlockHeader_Scheme, []); // decode transactions

  var transactions = [];
  var txIterator = getBlockResponseMsg.getMessageArrayIterator(3);
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = txIterator[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var tx = _step8.value;

      var _tx = _slicedToArray(tx, 1),
          txBuf = _tx[0];

      var txMsg = new InternalMessage(txBuf, txBuf.byteLength, SignedTransaction_Scheme, []);
      var transactionBuf = txMsg.getMessage(0);
      var transactionMsg = new InternalMessage(transactionBuf, transactionBuf.byteLength, Transaction_Scheme, []); // decode method arguments

      var inputArgumentArray = packedArgumentsDecode(transactionMsg.rawBufferWithHeaderForField(6, 0)); // decode signer

      var signerPublicKey = undefined;
      var signerBuf = transactionMsg.getMessage(3);
      var signerMsg = new InternalMessage(signerBuf, signerBuf.byteLength, Signer_Scheme, Signer_Unions);

      var _signerMsg$isUnionInd = signerMsg.isUnionIndex(0, 0, 0),
          _signerMsg$isUnionInd2 = _slicedToArray(_signerMsg$isUnionInd, 2),
          isEddsaSigner = _signerMsg$isUnionInd2[0],
          eddsaSignerOff = _signerMsg$isUnionInd2[1];

      if (isEddsaSigner) {
        var eddsaSignerBuf = signerMsg.getMessageInOffset(eddsaSignerOff);
        var eddsaSignerMsg = new InternalMessage(eddsaSignerBuf, eddsaSignerBuf.byteLength, EdDSA01Signer_Scheme, []);
        signerPublicKey = eddsaSignerMsg.getBytes(1);
      } // add transaction


      var txHash = calcTxHash(transactionBuf);
      var txTimestamp = transactionMsg.getUint64(2);
      transactions.push({
        txHash: txHash,
        txId: generateTxId(txHash, txTimestamp),
        protocolVersion: transactionMsg.getUint32(0),
        virtualChainId: transactionMsg.getUint32(1),
        timestamp: unixNanoToDate(txTimestamp),
        signerPublicKey: signerPublicKey,
        contractName: transactionMsg.getString(4),
        methodName: transactionMsg.getString(5),
        inputArguments: inputArgumentArray,
        executionResult: undefined,
        outputArguments: undefined,
        outputEvents: undefined
      });
    } // decode receipts

  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  var receiptIterator = getBlockResponseMsg.getMessageArrayIterator(6);
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = receiptIterator[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var receipt = _step9.value;

      var _receipt = _slicedToArray(receipt, 1),
          receiptBuf = _receipt[0];

      var receiptMsg = new InternalMessage(receiptBuf, receiptBuf.byteLength, TransactionReceipt_Scheme, []);
      var receiptTxHash = receiptMsg.getBytes(0);

      for (var _i = 0, _transactions = transactions; _i < _transactions.length; _i++) {
        var transaction = _transactions[_i];

        if (uint8ArrayEquals(transaction.txHash, receiptTxHash)) {
          // decode execution result
          var executionResult = executionResultDecode(receiptMsg.getUint16(1));
          transaction.executionResult = executionResult; // decode method arguments

          var outputArgumentArray = packedArgumentsDecode(receiptMsg.rawBufferWithHeaderForField(2, 0));
          transaction.outputArguments = outputArgumentArray; // decode events

          var outputEventArray = packedEventsDecode(receiptMsg.rawBufferWithHeaderForField(3, 0));
          transaction.outputEvents = outputEventArray;
        }
      }
    } // return

  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return {
    requestStatus: requestStatus,
    blockHeight: requestResultMsg.getUint64(1),
    blockTimestamp: unixNanoToDate(requestResultMsg.getUint64(2)),
    transactionsBlockHash: calcSha256(transactionsBlockHeaderMsg.rawBuffer()),
    transactionsBlockHeader: {
      protocolVersion: transactionsBlockHeaderMsg.getUint32(0),
      virtualChainId: transactionsBlockHeaderMsg.getUint32(1),
      blockHeight: transactionsBlockHeaderMsg.getUint64(2),
      prevBlockHash: transactionsBlockHeaderMsg.getBytes(3),
      timestamp: unixNanoToDate(transactionsBlockHeaderMsg.getUint64(4)),
      numTransactions: transactionsBlockHeaderMsg.getUint32(7)
    },
    resultsBlockHash: calcSha256(resultsBlockHeaderMsg.rawBuffer()),
    resultsBlockHeader: {
      protocolVersion: resultsBlockHeaderMsg.getUint32(0),
      virtualChainId: resultsBlockHeaderMsg.getUint32(1),
      blockHeight: resultsBlockHeaderMsg.getUint64(2),
      prevBlockHash: resultsBlockHeaderMsg.getBytes(3),
      timestamp: unixNanoToDate(resultsBlockHeaderMsg.getUint64(4)),
      transactionsBlockHash: resultsBlockHeaderMsg.getBytes(7),
      numTransactionReceipts: resultsBlockHeaderMsg.getUint32(9)
    },
    transactions: transactions
  };
}

function uint8ArrayEquals(a, b) {
  if (a.byteLength != a.byteLength) {
    return false;
  }

  for (var i = 0; i < a.byteLength; i++) {
    if (a[i] != b[i]) {
      return false;
    }
  }

  return true;
}

var PROTOCOL_VERSION = 1;
var CONTENT_TYPE_MEMBUFFERS = "application/membuffers";
var SEND_TRANSACTION_URL = "/api/v1/send-transaction";
var RUN_QUERY_URL = "/api/v1/run-query";
var GET_TRANSACTION_STATUS_URL = "/api/v1/get-transaction-status";
var GET_TRANSACTION_RECEIPT_PROOF_URL = "/api/v1/get-transaction-receipt-proof";
var GET_BLOCK_URL = "/api/v1/get-block";

var Client =
/*#__PURE__*/
function () {
  function Client(endpoint, virtualChainId, networkType) {
    _classCallCheck(this, Client);

    this.endpoint = endpoint;
    this.virtualChainId = virtualChainId;
    this.networkType = networkType;
  }

  _createClass(Client, [{
    key: "createTransaction",
    value: function createTransaction(publicKey, privateKey, contractName, methodName, inputArguments) {
      var _encodeSendTransactio = encodeSendTransactionRequest({
        protocolVersion: PROTOCOL_VERSION,
        virtualChainId: this.virtualChainId,
        timestamp: new Date(),
        networkType: this.networkType,
        publicKey: publicKey,
        contractName: contractName,
        methodName: methodName,
        inputArguments: inputArguments
      }, privateKey),
          _encodeSendTransactio2 = _slicedToArray(_encodeSendTransactio, 2),
          req = _encodeSendTransactio2[0],
          rawTxId = _encodeSendTransactio2[1];

      return [req, encodeHex(rawTxId)];
    }
  }, {
    key: "createQuery",
    value: function createQuery(publicKey, contractName, methodName, inputArguments) {
      return encodeRunQueryRequest({
        protocolVersion: PROTOCOL_VERSION,
        virtualChainId: this.virtualChainId,
        timestamp: new Date(),
        networkType: this.networkType,
        publicKey: publicKey,
        contractName: contractName,
        methodName: methodName,
        inputArguments: inputArguments
      });
    }
  }, {
    key: "createGetTransactionStatusPayload",
    value: function createGetTransactionStatusPayload(txId) {
      var rawTxId = decodeHex(txId);
      return encodeGetTransactionStatusRequest({
        protocolVersion: PROTOCOL_VERSION,
        virtualChainId: this.virtualChainId,
        txId: rawTxId
      });
    }
  }, {
    key: "createGetTransactionReceiptProofPayload",
    value: function createGetTransactionReceiptProofPayload(txId) {
      var rawTxId = decodeHex(txId);
      return encodeGetTransactionReceiptProofRequest({
        protocolVersion: PROTOCOL_VERSION,
        virtualChainId: this.virtualChainId,
        txId: rawTxId
      });
    }
  }, {
    key: "createGetBlockPayload",
    value: function createGetBlockPayload(blockHeight) {
      return encodeGetBlockRequest({
        protocolVersion: PROTOCOL_VERSION,
        virtualChainId: this.virtualChainId,
        blockHeight: blockHeight
      });
    }
  }, {
    key: "sendTransaction",
    value: function () {
      var _sendTransaction = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(rawTransaction) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.sendHttpPost(SEND_TRANSACTION_URL, rawTransaction);

              case 2:
                res = _context.sent;
                return _context.abrupt("return", decodeSendTransactionResponse(res));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendTransaction(_x) {
        return _sendTransaction.apply(this, arguments);
      }

      return sendTransaction;
    }()
  }, {
    key: "sendQuery",
    value: function () {
      var _sendQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(rawQuery) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.sendHttpPost(RUN_QUERY_URL, rawQuery);

              case 2:
                res = _context2.sent;
                return _context2.abrupt("return", decodeRunQueryResponse(res));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendQuery(_x2) {
        return _sendQuery.apply(this, arguments);
      }

      return sendQuery;
    }()
  }, {
    key: "getTransactionStatus",
    value: function () {
      var _getTransactionStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(txId) {
        var payload, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = this.createGetTransactionStatusPayload(txId);
                _context3.next = 3;
                return this.sendHttpPost(GET_TRANSACTION_STATUS_URL, payload);

              case 3:
                res = _context3.sent;
                return _context3.abrupt("return", decodeGetTransactionStatusResponse(res));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTransactionStatus(_x3) {
        return _getTransactionStatus.apply(this, arguments);
      }

      return getTransactionStatus;
    }()
  }, {
    key: "getTransactionReceiptProof",
    value: function () {
      var _getTransactionReceiptProof = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(txId) {
        var payload, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                payload = this.createGetTransactionReceiptProofPayload(txId);
                _context4.next = 3;
                return this.sendHttpPost(GET_TRANSACTION_RECEIPT_PROOF_URL, payload);

              case 3:
                res = _context4.sent;
                return _context4.abrupt("return", decodeGetTransactionReceiptProofResponse(res));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTransactionReceiptProof(_x4) {
        return _getTransactionReceiptProof.apply(this, arguments);
      }

      return getTransactionReceiptProof;
    }()
  }, {
    key: "getBlock",
    value: function () {
      var _getBlock = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(blockHeight) {
        var payload, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payload = this.createGetBlockPayload(blockHeight);
                _context5.next = 3;
                return this.sendHttpPost(GET_BLOCK_URL, payload);

              case 3:
                res = _context5.sent;
                return _context5.abrupt("return", decodeGetBlockResponse(res));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getBlock(_x5) {
        return _getBlock.apply(this, arguments);
      }

      return getBlock;
    }()
  }, {
    key: "sendHttpPost",
    value: function () {
      var _sendHttpPost = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(relativeUrl, payload) {
        var res, contentType;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!payload || payload.byteLength == 0)) {
                  _context6.next = 2;
                  break;
                }

                throw new Error("payload sent by http is empty");

              case 2:
                _context6.next = 4;
                return axios.post(this.endpoint + relativeUrl, payload, {
                  headers: {
                    "content-type": CONTENT_TYPE_MEMBUFFERS
                  },
                  responseType: "arraybuffer",
                  validateStatus: function validateStatus(status) {
                    return true;
                  }
                });

              case 4:
                res = _context6.sent;
                // check if we have the content type response we expect
                contentType = res.headers["content-type"];

                if (!(contentType != CONTENT_TYPE_MEMBUFFERS)) {
                  _context6.next = 12;
                  break;
                }

                if (!(contentType == "text/plain" || contentType == "application/json")) {
                  _context6.next = 11;
                  break;
                }

                throw new Error("http request failed: ".concat(getTextDecoder().decode(res.data)));

              case 11:
                throw new Error("http request failed with unexpected Content-Type '".concat(contentType, "'"));

              case 12:
                if (res.data) {
                  _context6.next = 14;
                  break;
                }

                throw new Error("no response data available, http status: ".concat(res.status, " ").concat(res.statusText));

              case 14:
                if (!(res.data.constructor === ArrayBuffer)) {
                  _context6.next = 16;
                  break;
                }

                return _context6.abrupt("return", new Uint8Array(res.data));

              case 16:
                return _context6.abrupt("return", res.data);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendHttpPost(_x6, _x7) {
        return _sendHttpPost.apply(this, arguments);
      }

      return sendHttpPost;
    }()
  }]);

  return Client;
}();

export { createAccount, addressToBytes, bytesToAddress, ExecutionResult, RequestStatus, Client, calcClientAddressOfEd25519PublicKey, encodeHex, decodeHex, argUint32$$1 as argUint32, argUint64$$1 as argUint64, argString$$1 as argString, argBytes$$1 as argBytes, argAddress$$1 as argAddress, NetworkType };